import { render, staticRenderFns } from "./RezoningModal.vue?vue&type=template&id=522d06bd"
import script from "./RezoningModal.vue?vue&type=script&lang=js"
export * from "./RezoningModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports